import React from 'react';
import ReactAudioPlayer from 'react-audio-player';

import buttonLeft from "../assets/images/tetris/left.png";
import buttonRight from "../assets/images/tetris/right.png";
import buttonUp from "../assets/images/tetris/up.png";
import buttonDown from "../assets/images/tetris/down.png";

import iconScore from "../assets/images/Icon_Star.png";

import piece1 from "../assets/images/tetris/piece1.png";
import piece2 from "../assets/images/tetris/piece2.png";
import piece3 from "../assets/images/tetris/piece3.png";
import piece4 from "../assets/images/tetris/piece4.png";
import piece5 from "../assets/images/tetris/piece5.png";
import piece6 from "../assets/images/tetris/piece6.png";
import piece7 from "../assets/images/tetris/piece7.png";

import useScreenOrientation from './helpers/useScreenOrientation';

export default function SceneUI({ isVisible, playGame, setHorizontalMovement, setVerticalMovement, userScoreUI, userTimeUI, userLifesUI, setUserScore, setUserTime, setIsGameLoaded, setUserLifes, gameOver, soundMuted}: any) {
  
  const pcURL = "./pc/tetris/v6/index.html";
  const isLandscape = useScreenOrientation();
  const iframeRef = React.useRef<HTMLIFrameElement>(null);
  
  const [shapeIcon, setShapeIcon] = React.useState(piece1);
  const [startTime, setStartTime] = React.useState<number>(0);

  const GetMessageFromIframe = React.useCallback((event: MessageEvent) => {
    if (event.origin !== window.origin){
      console.error("React: Mensaje de un origen distinto")
      return;
    }
    if(event.data.manager === 'loaded'){
      setIsGameLoaded(true);
    }
    if(event.data.manager === 'score'){
      setUserScore(event.data.message)
      const runTime = Math.floor((Date.now() - startTime) / 1000);
      setUserTime(runTime);
    }
    if(event.data.manager === 'gameover'){
      setStartTime(0);
      setUserLifes(0);
    }
    if(event.data.manager === 'shape'){
      if(event.data.message === 'purple') setShapeIcon(piece1);
      if(event.data.message === 'orange') setShapeIcon(piece2);
      if(event.data.message === 'yellow') setShapeIcon(piece3);
      if(event.data.message === 'green') setShapeIcon(piece4);
      if(event.data.message === 'blue') setShapeIcon(piece5);
      if(event.data.message === 'cyan') setShapeIcon(piece6);
      if(event.data.message === 'red') setShapeIcon(piece7);
    } 
  }, [setIsGameLoaded, setUserScore, setUserLifes, setUserTime, startTime]);

  React.useEffect(() => {
    window.addEventListener('message', GetMessageFromIframe);
    return () => {
      window.removeEventListener('message', GetMessageFromIframe);
    };
  }, [GetMessageFromIframe]);

  const SendMessageToPC = React.useCallback((manager: string, message: any) => {
    const iframeWindow = iframeRef.current?.contentWindow;
    if(!iframeWindow)
      return;
    const data = {sender: 'umbraint-react', recipient: 'umbraint-pc', manager: manager, message: message};
    iframeWindow.postMessage(data, '*');
  }, [iframeRef]);

  React.useEffect(() => {
    if(playGame === true){
      SendMessageToPC('command','start');
      setStartTime(Date.now());
    }
  },[playGame, SendMessageToPC]);

  const ButtonUp = React.useCallback(() => {
    SendMessageToPC('command','up');
  }, [SendMessageToPC]);

  const ButtonLeft = React.useCallback(() => {
    SendMessageToPC('command','left');
  }, [SendMessageToPC]);

  const ButtonRight = React.useCallback(() => {
    SendMessageToPC('command','right');
  }, [SendMessageToPC]);

  const ButtonDown = React.useCallback(() => {
    SendMessageToPC('command','down');
  }, [SendMessageToPC]);

  const handleKeyPress = React.useCallback((event: KeyboardEvent) => {
    if (event.key === 'ArrowLeft') {
      ButtonLeft();
    }
    if (event.key === 'ArrowRight') {
      ButtonRight();
    }
    if (event.key === 'ArrowUp' || event.key === ' ') {//last is spacebar
      ButtonUp();
    }
    if (event.key === 'ArrowDown') {
      ButtonDown();
    }
  }, [ButtonLeft, ButtonRight, ButtonUp, ButtonDown]);

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  },[handleKeyPress]);

  return (
    <div className={`full-sceneui-container ${isVisible === true ? 'active' : 'hidden'}`}>
      <div className={`sceneui-container ${isLandscape ? '' : 'portrait'}`}>

        <div className={`sceneui-container-header ${isLandscape ? '' : 'portrait'}`}>
          <div className={`sceneui-container-nextshape ${isLandscape ? '' : 'portrait'}`}>
            <div className={`sceneui-shape-text ${isLandscape ? '' : 'portrait'}`}>Siguiente</div>
            <img className={`sceneui-shape-icon ${isLandscape ? '' : 'portrait'}`} src={shapeIcon} alt=''/>
          </div>
          <div className={`sceneui-container-score ${isLandscape ? '' : 'portrait'}`}>
            <img className={`sceneui-score-icon ${isLandscape ? '' : 'portrait'}`} src={iconScore} alt=''/>
            <div className={`sceneui-shape-text ${isLandscape ? '' : 'portrait'}`}>{userScoreUI}</div>
          </div>
        </div>

        <div className={`sceneui-container-pc ${isLandscape ? '' : 'portrait'}`}>
          <iframe ref={iframeRef} title='pc'
            className={`sceneui-container-game ${true ? 'visible' : ''}`}
            src={pcURL}
            allow={`xr-spatial-tracking; camera; fullscreen; microphone; gyroscope; accelerometer; scrolling='no' frameborder='0';`}
          />
        </div>

        <div className={`sceneui-container-controls ${isLandscape ? '' : 'portrait'}`}>
          <img className={`sceneui-container-controls-button ${isLandscape ? '' : 'portrait'}`} src={buttonLeft} alt='' onClick={() => ButtonLeft()}/>
          <img className={`sceneui-container-controls-button ${isLandscape ? '' : 'portrait'}`} src={buttonUp} alt='' onClick={() => ButtonUp()}/>
          <img className={`sceneui-container-controls-button ${isLandscape ? '' : 'portrait'}`} src={buttonDown} alt='' onClick={() => ButtonDown()}/>
          <img className={`sceneui-container-controls-button ${isLandscape ? '' : 'portrait'}`} src={buttonRight} alt='' onClick={() => ButtonRight()}/>
        </div>
        
      </div>
      {gameOver === true && <div className="sceneui-gameover-container"><div className={`sceneui-gameover-text ${isLandscape ? '' : 'portrait'}`}>¡Fin del Juego!</div></div>}
      <ReactAudioPlayer src={require("../assets/sounds/AvaLow-ThroughThePrism.mp3")} autoPlay loop controls={false} muted={soundMuted} id={"backgroundMusic"} volume={0.2} />
    </div>
  );
}
